/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
`;
